export default {
    teams: [
        { team_id: '108', value: 'LAA', name: 'Angels' },
        { team_id: '117', value: 'HOU', name: 'Astros' },
        { team_id: '133', value: 'OAK', name: 'Athletics' },
        { team_id: '141', value: 'TOR', name: 'Blue Jays' },
        { team_id: '144', value: 'ATL', name: 'Braves' },
        { team_id: '158', value: 'MIL', name: 'Brewers' },
        { team_id: '138', value: 'STL', name: 'Cardinals' },
        { team_id: '112', value: 'CHC', name: 'Cubs' },
        { team_id: '109', value: 'ARI', name: 'D-backs' },
        { team_id: '119', value: 'LAD', name: 'Dodgers' },
        { team_id: '137', value: 'SF', name: 'Giants' },
        { team_id: '114', value: 'CLE', name: 'Guardians' },
        { team_id: '136', value: 'SEA', name: 'Mariners' },
        { team_id: '146', value: 'MIA', name: 'Marlins' },
        { team_id: '121', value: 'NYM', name: 'Mets' },
        { team_id: '120', value: 'WSH', name: 'Nationals' },
        { team_id: '110', value: 'BAL', name: 'Orioles' },
        { team_id: '135', value: 'SD', name: 'Padres' },
        { team_id: '143', value: 'PHI', name: 'Phillies' },
        { team_id: '134', value: 'PIT', name: 'Pirates' },
        { team_id: '140', value: 'TEX', name: 'Rangers' },
        { team_id: '139', value: 'TB', name: 'Rays' },
        { team_id: '113', value: 'CIN', name: 'Reds' },
        { team_id: '111', value: 'BOS', name: 'Red Sox' },
        { team_id: '115', value: 'COL', name: 'Rockies' },
        { team_id: '118', value: 'KC', name: 'Royals' },
        { team_id: '116', value: 'DET', name: 'Tigers' },
        { team_id: '142', value: 'MIN', name: 'Twins' },
        { team_id: '145', value: 'CWS', name: 'White Sox' },
        { team_id: '147', value: 'NYY', name: 'Yankees' },
    ],
    teamsById: [
        { value: '108', name: 'Angels' },
        { value: '117', name: 'Astros' },
        { value: '133', name: 'Athletics' },
        { value: '141', name: 'Blue Jays' },
        { value: '144', name: 'Braves' },
        { value: '158', name: 'Brewers' },
        { value: '138', name: 'Cardinals' },
        { value: '112', name: 'Cubs' },
        { value: '109', name: 'D-backs' },
        { value: '119', name: 'Dodgers' },
        { value: '137', name: 'Giants' },
        { value: '114', name: 'Guardians' },
        { value: '136', name: 'Mariners' },
        { value: '146', name: 'Marlins' },
        { value: '121', name: 'Mets' },
        { value: '120', name: 'Nationals' },
        { value: '110', name: 'Orioles' },
        { value: '135', name: 'Padres' },
        { value: '143', name: 'Phillies' },
        { value: '134', name: 'Pirates' },
        { value: '140', name: 'Rangers' },
        { value: '139', name: 'Rays' },
        { value: '113', name: 'Reds' },
        { value: '111', name: 'Red Sox' },
        { value: '115', name: 'Rockies' },
        { value: '118', name: 'Royals' },
        { value: '116', name: 'Tigers' },
        { value: '142', name: 'Twins' },
        { value: '145', name: 'White Sox' },
        { value: '147', name: 'Yankees' },
    ],
}
